module.exports = __webpack_public_path__ + "img/404.6bea2d5e.jpeg";